const origin = `https://jobs.sidehustles.com`;
const frame_id = `rh-iframe-overlay`;

function track_job_view(uuid) {
	if (!uuid || !window.RemoteHunterJobs) {
		return;
	}

	window.RemoteHunterJobs.trackJob(uuid).catch(() => null);
}

function get_url(job) {
	const params = new URLSearchParams({
		v: `3`,
		jobUuid: job.uuid || ``,
		jobName: job.title || ``,
		company: job.company_name || ``,
		description: job.description || ``,
		applyUrl: job.url || ``,
		parentUrl: window.location.href,
	});

	return `${origin}/widget/embed?${params.toString()}`;
}

function listen_for_close(e) {
	if (e.origin !== origin) {
		return;
	}

	if (e.data && e.data.type === `RH_WIDGET_CLOSE`) {
		close_popup();
	}
}

function close_popup() {
	const iframe_el = document.getElementById(frame_id);
	if (iframe_el) {
		iframe_el.remove();
	}

	window.removeEventListener(`message`, listen_for_close);
}

export function open_popup(job) {
	if (document.getElementById(frame_id)) {
		return;
	}

	const iframe_el = document.createElement(`iframe`);
	iframe_el.id = frame_id;
	iframe_el.src = get_url(job);
	iframe_el.title = `Resume Match Widget`;
	iframe_el.allow = `clipboard-write`;
	iframe_el.setAttribute(`aria-label`, `Resume Match Widget`);
	iframe_el.classList.add(`rh-widget-iframe`);
	document.body.appendChild(iframe_el);

	window.addEventListener(`message`, listen_for_close);

	track_job_view(job.uuid);
}
